import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@qga/roo-ui/components';
import Disclosure from '@/components/Disclosure';
import Heading from '@/components/Heading';
import Text from '@/v2/../components/Text';
import BlockContent from '@sanity/block-content-to-react';
import withProps from '@/components/withProps';
import Link from '@/components/Link';
import Case from 'case';

import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import { dataLayer } from '@/v2/utils/dataLayer';

const FAQs = ({ faqs, ga4Category }) => {
  const shouldUseNewEvents = useGA4Events();
  const [questionSlug, setQuestionSlug] = useState();

  const questionsToSlug = (question) => {
    return Case.kebab(question);
  };

  return (
    <Box bg="white" py={['5', null, '10']}>
      <Container>
        <Heading.h2
          textAlign={['left', null, 'center']}
          fontSize={['lg', null, '2xl']}
        >
          Frequently Asked Questions
        </Heading.h2>
        {faqs.map(({ question, answer }) => (
          <Box
            key={questionsToSlug(question)}
            width="100%"
            data-testid={`FAQ_SELECTED_${questionsToSlug(question)}`}
            onClick={() => {
              if (
                shouldUseNewEvents &&
                questionsToSlug(question) !== questionSlug
              ) {
                setQuestionSlug(questionsToSlug(question));
                dataLayer.accordionOpenEvent({
                  groupName: ga4Category + '-page',
                  itemName: question,
                });
              }
            }}
          >
            <Disclosure
              key={question}
              headerTitle={question}
              expand={false}
              variant="default"
              headerStyles={{
                fontSize: ['sm', null, 'base'],
                pt: 3,
                pb: 1,
              }}
            >
              <BlockContent
                blocks={answer}
                serializers={{
                  types: {
                    block: withProps(({ node }) => ({
                      ...(node.style === 'normal' && {
                        fontSize: 'sm',
                        display: 'inline-block',
                        lineHeight: 1.5,
                      }),
                    }))(Text),
                  },
                  marks: {
                    link: withProps(({ mark }) => ({
                      href: mark.href,
                      external: true,
                    }))(Link.Text),
                  },
                }}
              />
            </Disclosure>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

FAQs.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.question,
      answer: PropTypes.any,
    }),
  ).isRequired,
  ga4Category: PropTypes.string,
};

export default FAQs;
